import { useState } from 'react';
import { ApplicationsQueue } from './ApplicationsQueue';
import { UatAssessField } from './UatAssessField';

/**
 * Partners landing page (Phase 5d-1, Decisions 5-26 + 5-27).
 *
 * Internal tab strip per Channel Partner Ref v5 §6:
 *
 *   Applications         (single unified queue covering ALL Brief states —
 *                         pending review through active partners. Filter
 *                         pills + sort + search narrow to the relevant
 *                         subset. UAT 30 May 2026 folded the previously-
 *                         separate Active Partners tab into here on the
 *                         grounds that Briefs transitioning from Approved
 *                         → Active should not vanish + re-appear in another
 *                         tab.)
 *   Commission Approvals (disabled stub — Phase 7)
 *
 * Deactivate / Reactivate / Activate-skip-backlink actions live on the
 * Brief detail page (StaffActionZone), reached by clicking a queue row.
 */
type Tab = 'applications' | 'commission-approvals';

export function PartnersLandingPage() {
  const [active, setActive] = useState<Tab>('applications');

  return (
    <div className="portal-partners-page">
      <header className="portal-partners-header">
        <h1>Partners</h1>
        <p className="portal-partners-subtitle">
          Partner programme administration — applications, active partners, commission approvals.
        </p>
      </header>

      <UatAssessField />

      <nav className="portal-partners-tabs" aria-label="Partners sections">
        <button
          type="button"
          className={`portal-partners-tab${active === 'applications' ? ' active' : ''}`}
          aria-current={active === 'applications' ? 'page' : undefined}
          onClick={() => setActive('applications')}
        >
          Applications
        </button>
        <button
          type="button"
          className="portal-partners-tab disabled"
          disabled
          aria-disabled="true"
          title="Commission Approvals — Phase 7"
        >
          Commission Approvals
        </button>
      </nav>

      {active === 'applications' && <ApplicationsQueue />}
    </div>
  );
}
